import React from 'react'
import protivitiimg from '../Components/Image/protiviti.png'
import AuthHandlerInstance from '../Classes/AuthHandler'
class SideDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        var roles = AuthHandlerInstance.getRoles()
        var groups = AuthHandlerInstance.getGroups()
        document.addEventListener("DOMContentLoaded", function () {
            if (window.innerWidth < 992) {
                document.querySelectorAll('.sidebar .nav-link').forEach(function (element) {
                    element.addEventListener('click', function (e) {
                        let nextEl = element.nextElementSibling;
                        let parentEl = element.parentElement;
                        let allSubmenus_array = parentEl.querySelectorAll('.submenu');
                        if (nextEl && nextEl.classList.contains('submenu')) {
                            e.preventDefault();
                            if (nextEl.style.display == 'block') {
                                nextEl.style.display = 'none';
                            } else {
                                nextEl.style.display = 'block';
                            }
                        }
                    });
                })
            }
        })
        return (
            <nav className="side-drawer-Toggle text-white side-bar-menu" style={{ width: '20%' }}>
                <div className="main-menu ">

                    <ul className="text-uppercase pl-5" style={{ cursor: 'pointer' }}>
                        <li className="py-2">
                            <a style={{ textDecoration: 'none', color: 'white' }} href={roles[5] ? "/SubmitPOAcceptance" : "/RequestPOAcceptance"} className="side-links">Purchase Orders</a>
                        </li>
                        {
                            roles[1] || roles[2] || roles[3] || roles[6] || roles[7] || roles[12] || roles[20] || roles[21] || roles[22] || roles[23] || roles[24] || roles[54] ?
                                <li className='py-2'>
                                    <a style={{ textDecoration: 'none', color: 'white' }}>QA & INSPECTIONS <b className="menu-icon">&#9656;</b></a>
                                    <ul className='submenu'>
                                        <li className='multi-level-menu'> <a href="/QAplanningdashboard" className="side-links nav-link">QA Planning</a></li>
                                        <li className='multi-level-menu'> <a href={roles[5] ? "/SupplierInspection" : "/inspectiondashboard"} className="side-links nav-link">Inspections</a></li>
                                        <li className='multi-level-menu'> <a href="/resource-planner" className="side-links nav-link">Resource Planner</a></li>
                                    </ul>
                                </li>
                                : null
                        }
                        {
                            !roles[5] ?
                                <li className='py-2'>
                                    <a style={{ textDecoration: 'none', color: 'white' }}>Expediting <b className="float-end">&#9656;</b></a>
                                    <ul className='submenu'>
                                        <li className='multi-level-menu'><a href="/ExpiditingDashboard" className="side-links nav-link">Expediting Dashboard</a></li>
                                    </ul>
                                </li>
                                : null
                        }
                        {roles[7] || roles[17] || roles[8] || roles[9] || roles[10] ?
                            <li className='py-2'>
                                <a style={{ textDecoration: 'none', color: 'white' }}>Invoices <b className="float-end">&#9656;</b></a>
                                <ul className='submenu'>
                                    <li className='multi-level-menu'> <a href={roles[7] || roles[10] || roles[12] ? "/SendforPayment" : roles[8] && groups[9] ? "/UploadPaymentAcknowledgement" : "/RequestPayment"} className='side-links nav-link'>Payments</a></li>
                                    <li className='multi-level-menu'><a href="/AdvancedReceivePayments" className="side-links nav-link">Invoices</a></li>
                                </ul>
                            </li>
                            : null
                        }
                        <li className='py-2'>
                            <a style={{ textDecoration: 'none', color: 'white' }}>Dispatch <b className="float-end">&#9656;</b></a>
                            <ul className='submenu'>
                                <li className='multi-level-menu'><a href={roles[12] || roles[54] ? "/ManufacturingClearence" : null} className="side-links nav-link">Manufacturing Clearence</a></li>
                                <li className='multi-level-menu'><a href={!roles[5] ? "/DispatchClearanceTable" : null} className="side-links nav-link">IC List</a></li>
                                <li className='multi-level-menu'><a href="/DCListing" className="side-links nav-link">Dispatch</a></li>
                            </ul>
                        </li>
                        <li className='py-2'>
                            <a style={{ textDecoration: 'none', color: 'white' }}>Tutorials <b className="float-end">&#9656;</b></a>
                            <ul className='submenu'>
                                <li className='multi-level-menu'><a href='/manuals' className="side-links nav-link">Manuals</a></li>
                                <li className='multi-level-menu'><a href="/videos" className="side-links nav-link">Videos</a></li>
                            </ul>
                        </li>
                        <li className="py-2">
                            <a style={{ textDecoration: 'none', color: 'white' }} href="/BlankDocuments" className="side-links">Blank Documents</a>
                        </li>
                    </ul>
                </div>

                <div className="mt-4 bottom-menu pl-0" >
                    <ul className=" pl-4" >
                        <li className=" py-2">

                        </li>

                        <li className='AlignBottom' >
                            <div className="poweredbytext"  >powered by</div>
                            <img className="py-2 protivitilogo" src={protivitiimg} />
                        </li>
                    </ul>
                </div>
            </nav>
        )
    }
}

export default SideDrawer